module.exports = __webpack_public_path__ + "media/images/voting_2-adbbd47ddcb31273fd7c812ba8cb3325.svg";